import React, { useState } from "react";
import styled from "styled-components/macro";
import residential from "../../../images/unit/wizard/residential.svg";
import student from "../../../images/unit/wizard/student.svg";
import office from "../../../images/unit/wizard/office.svg";
import community from "../../../images/unit/wizard/municipality.svg";
import hospitality from "../../../images/unit/wizard/hospitality.svg";
import retail from "../../../images/unit/wizard/retail.svg";
import residentialChosen from "../../../images/unit/wizard/residential-chosen.svg";
import studentChosen from "../../../images/unit/wizard/student-chosen.svg";
import officeChosen from "../../../images/unit/wizard/office-chosen.svg";
import communityChosen from "../../../images/unit/wizard/municipality-chosen.svg";
import hospitalityChosen from "../../../images/unit/wizard/hospitality-chosen.svg";
import retailChosen from "../../../images/unit/wizard/retail-chosen.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { StyledBlackButton } from "../../ButtonsStyle";

const WizardUnitStep2 = ({
  onClick,
  onBackPress,
  property: initProperty,
  setProperty: initSetProperty,
}) => {
  const properties = [
    {
      title: "Residential",
      image: residential,
      chosen: residentialChosen,
      key: "residential",
    },
    {
      title: "Student housing",
      image: student,
      chosen: studentChosen,
      key: "studentHousing",
    },
    { title: "Office", image: office, chosen: officeChosen, key: "office" },
    {
      title: "Community",
      image: community,
      chosen: communityChosen,
      key: "community",
    },
    {
      title: "Hospitality",
      image: hospitality,
      chosen: hospitalityChosen,
      key: "hospitality",
    },
    { title: "Retail", image: retail, chosen: retailChosen, key: "retail" },
  ];

  const different = { title: "Different", key: "other" };

  const [property, setProperty] = useState(
    initProperty
      ? initProperty.title === different.title
        ? 6
        : properties.findIndex((e) => e.title === initProperty.title)
      : -1
  );

  const _renderProperties = () => {
    return properties.map((item, index) => {
      return (
        <Section
          index={index}
          className={`animate__animated animate__fadeIn`}
          onClick={() => {
            initSetProperty(index === 6 ? different : properties[index]);
            setProperty(index);
          }}
          key={item.title}
        >
          <img
            height={150}
            src={property === index ? item.chosen : item.image}
            alt={"residential"}
          />
          <Title style={{ marginTop: "5px" }} fontSize={20}>
            {item.title.toUpperCase()}
          </Title>
          <Radio>{property === index && <InnerRadio />}</Radio>
        </Section>
      );
    });
  };

  return (
    <Wrapper>
      <TitleWrapper>
        <div
          onClick={onBackPress}
          style={{ padding: "10px 20px", cursor: "pointer" }}
        >
          <FontAwesomeIcon size={"lg"} color={"#4b4b4b"} icon={faArrowLeft} />
        </div>
        <Title fontSize={35}>What is your property type?</Title>
      </TitleWrapper>
      <ImagesWrapper>{_renderProperties()}</ImagesWrapper>
      <Section
        style={{ padding: "9px 0", flexDirection: "row", width: "100%" }}
        onClick={() => setProperty(6)}
      >
        <Radio
          style={{
            width: "18px",
            height: "18px",
          }}
        >
          {property === 6 && <InnerRadio />}
        </Radio>
        <Title style={{ margin: "8px" }} fontSize={16}>
          I have different types of assets
        </Title>
      </Section>

      <StyledBlackButton
        disabled={property === -1}
        onClick={onClick}
        style={{
          marginTop: "5px",
          backgroundColor: property === -1 ? "#a1a0a0" : "#606060",
          color: "#FFFFFF",
          fontSize: "20px",
          fontFamily: " Manrope,serif",
          padding: "10px 40px",
        }}
      >
        Next
      </StyledBlackButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const Radio = styled.div`
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  padding: 4px;
  border: 1px solid #13647b;
`;

const InnerRadio = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #13647b;
  border-radius: 50%;
`;

const Section = styled.div`
  cursor: pointer;
  align-items: center;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  //height: 200px;
  width: 340px;
  animation-delay: ${({ index }) => 60 * index}ms;
`;

const ImagesWrapper = styled.div`
  align-items: start;
  justify-content: center;
  position: relative;
  flex-direction: row;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

const Title = styled.div`
  padding: 10px 0;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 50 }) => fontSize}px;
  white-space: pre-wrap;
  text-align: center;
  font-family: Manrope, serif;
`;
const TitleWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;
export { WizardUnitStep2 };
